











import Vue from 'vue';
import PeerGroupListCreator from '@/components/PeerGroupListCreator.vue';

export default Vue.extend({
  components: {
    PeerGroupListCreator
  },

  props: {
    initialName: String,
    value: Boolean
  },

  computed: {
    // Opened and closed by the parent through v-model.
    isOpen: {
      get(): boolean {
        return this.value;
      },
      set(open: boolean) {
        this.$emit('input', open);
      }
    }
  },

  methods: {
    onCreate(groupInfo: {
      name: string;
      section: string;
      description: string;
    }) {
      this.$emit('create-group', groupInfo);

      this.close();
    },

    close() {
      this.isOpen = false;
    }
  }
});
